<template>
  <div :class="classes" v-loading="loading">
     <pt-page-title title="基因检测套餐" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey" keyName="name">
        <router-link to="/detection-package-new" slot="before-left"><el-button type="primary">新建基因检测套餐</el-button></router-link>
     </pt-page-title>
     <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
          <template>
            <el-button type="primary" @click="Filter(false)">筛选</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter>
     <!-- 表格 -->
    <pt-detection-package-table :tableLabels="currentTableLabels" ref="table" :paramsData="paramsData" :isFromRouter="isFromRouter">
      <template slot-scope="scope">
        <i class="iconfont icon-xiangqing pointer" @click="goDetail(scope.row)"></i>
        <i class="iconfont icon-bianji pointer" @click="goEdit(scope.row)"></i>
        <i class="iconfont icon-shanchu pointer" @click="goDelete(scope.row)"></i>
      </template>
    </pt-detection-package-table>
  </div>
</template>

<script>
// 组件class前缀
import { tableLabels, filterLabels } from './detection-package-options.js'
import ptDetectionPackageTable from './pt-detection-package-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
const prefixCls = 'pt-detection-package-list'

export default {
  name: 'pt-detection-package-list',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    currentTableLabels () {
      return tableLabels
    }
  },
  props: {
    seqTypes: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    seqTypes: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'sequencingTechnologyType') {
            item.options = val
          }
        })
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    ptDetectionPackageTable
  },
  data () {
    return {
      loading: false,
      filterLabels: filterLabels,
      paramsData: {},
      params: {},
      isFromRouter: false,
      searchKey: ''
    }
  },
  methods: {
    emptySearch () {
    //   this.params.name = null
      this.$delete(this.paramsData, 'name')
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
      }
      if (!isFromRouter) {
        this.searchKey = null
        if (this.params.name) {
          this.$delete(this.params, 'name')
        }
      }
      this.paramsData = JSON.parse(JSON.stringify(this.params))
      this.$nextTick(_ => {
        if (!this.isFromRouter) {
          this.$refs.filter.getAddRouter(this.paramsData)
        }
      })
    },
    cleanParams () {
      emptyObject(this.params)
      this.Filter()
    },
    goEdit (data) {
      this.$router.push({ name: 'detection-package-update', params: { id: data.id } })
    },
    goDetail (data) {
      this.$router.push({ name: 'detection-package-detail', params: { id: data.id } })
    },
    goDelete (data) {
      this.$confirm('确定要删除基因套餐“' + data.name + '”?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deleteDetectionPackage', data.id).then(res => {
          this.$refs.table.reload()
          this.$message.success('成功删除了基因套餐' + data.name + '!')
          this.loading = false
        }).catch(err => {
          this.loading = false
          console.error(err)
          this.$message.error(err)
        })
      })
    },
    search (key) {
      this.searchKey = key
      emptyObject(this.params)
      emptyObject(this.paramsData)
      this.$set(this.paramsData, 'name', key)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
